const getNodeTypeMatrix = {
  leak: 'Water Sensor',
  leak2: 'V2 Water Sensor',
  leak3: 'V3 Leak Sensor',
  motion: 'Temperature Sensor',
  motion2: 'V2 Temperature Sensor',
  probe: 'Pipe Sensor',
  probe2: 'V2 Pipe Temperature Sensor',
  temp3: 'V3 Temp Sensor',
  nbiot_leak: 'Leak & Freeze Sensor',
  gateway: 'Gateway',
  kerlink_wifi_gateway: 'Link Gateway',
  bvs: 'Defender Water Shutoff',
  bvs2: 'Defender Water Shutoff',
  leak5s: 'Defender Slim',
  whiskerting: 'Whisker Ting',
  cxamnas1: 'Calyx NH3 Sensor',
  aqua_scope_monitor_ps: 'Aqua Scope',
  'strips-drip': 'Sensative Water Sensor',
} as Record<string, string>

export default getNodeTypeMatrix
